function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Do not change anything in the protected area. Doing so will be detected and your commit will be rejected.

// Protected Area Start

import { Channel } from './Channel';
class RunEngine {
  constructor() {
    _defineProperty(this, "debugLog", function (tag) {
      let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      console.log('=====================Debug Log Start======================');
      if (data !== undefined) {
        console.log(tag + '====>' + JSON.stringify(data));
      }
      console.log('=====================Debug Log End======================');
      console.log('        ');
    });
    this.channels = new Map();
    this.addChannel = this.addChannel.bind(this);
    this.attachBuildingBlock = this.attachBuildingBlock.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.unSubscribeFromMessages = this.unSubscribeFromMessages.bind(this);
  }
  addChannel(topic) {
    this.channels.set(topic, new Channel(topic));
  }
  unSubscribeFromMessages(block, subscribedMessages) {
    if (subscribedMessages) {
      subscribedMessages.forEach(topic => {
        const channel = this.channels.get(topic);
        if (channel) {
          channel.unsub(block);
        }
      });
    }
  }
  attachBuildingBlock(block, subscribedMessages) {
    subscribedMessages.forEach(topic => {
      if (!this.channels.has(topic)) {
        this.addChannel(topic);
      }
      const channel = this.channels.get(topic);
      if (channel) {
        channel.sub(block);
      }
    });
  }
  sendMessage(from, message) {
    if (message && message.id) {
      const channel = this.channels.get(message.id);
      if (channel) {
        channel.subscribers.forEach(block => block.receive(from, message));
      }
    }
  }
}
const runEngine = new RunEngine();
export { runEngine };

// Protected Area End